import React from 'react';
import { Card, Grid, Header } from 'semantic-ui-react';

import ClaimSummary from '../../ClaimSummary';
import Form from './Form';
import PathView from '../../PathView';
import Content from '../../Content';
import TaskContainer from '../../TaskContainer';
import getTaskTitle from '../../../utils/getTaskTitle';

const TaskView = ({ task, claim, loading, onClaimClosed, ...rest }) => {
  const { createdAt, id, priority, claimId } = task;
  return (
    <Content fullWidth>
      <PathView
        paths={[
          { name: 'Tasks', path: '/tasks' },
          { name: id, path: `/task/${id}` }
        ]}
      />
      <TaskContainer
        title={getTaskTitle(task)}
        date={createdAt}
        id={id}
        priority={priority}
        icon="hashtag"
        claimId={claimId}
        loading={loading}
        hideClaim={false}
        onClaimClosed={onClaimClosed}
      >
        <Card.Description>
          <Grid>
            <Grid.Row>
              <Grid.Column width={5}>
                <ClaimSummary claim={claim} />
              </Grid.Column>
              <Grid.Column width={11}>
                <Grid>
                  <Grid.Row>
                    <Grid.Column>
                      <Header>Passenger comment:</Header>
                      {claim ? claim.correctedInformation : ''}
                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row>
                    <Grid.Column>
                      {claim && <Form taskId={id} claim={claim} {...rest} />}
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Card.Description>
      </TaskContainer>
    </Content>
  );
};

export default TaskView;



// WEBPACK FOOTER //
// ./src/component/tasks/CorrectClaimTask/TaskView.js